<template>
  <div class="">
    <wizard-page-header :stepTitle="stepTitle" :readonly="readonly"></wizard-page-header>

    <div :class="[readonly && 'opacity-70 pointer-events-none']" class="content-container">
      <a-spin :spinning="submitting">
        <a-row>
          <a-col :lg="6" :xs="0">
            <new-order-sidebar
              :canAdd="true"
              :order_items="$store.state.order.order_items"
              :stopAfterStep="2"
              :onInstrumentFormCompleted="onInstrumentFormCompleted"
              :readonly="readonly"
            />
          </a-col>
          <a-col :lg="18" :xs="24" class="px-4 pb-16">
            <h2 class="hidden mb-10 text-2xl md:block">{{ contentTitle }}</h2>

            <a-card
              v-for="order_item in $store.state.order.order_items"
              :key="order_item.id"
              class="mb-8"
            >
              <h2 class="text-xl font-bold text-white" slot="title">
                {{ order_item.item_name_copy }}
              </h2>

              <div slot="extra" class="">
                <euro-value
                  :value="order_item.value"
                  class="text-xl font-bold text-white"
                  smallerDecimals
                  symbolBefore
                  hideDecimalsIfZero
                />
              </div>

              <a-form :form="form" @submit="handleSubmit">
                <a-row :gutter="16">
                  <a-col
                    v-if="surveys[order_item.id] && surveys[order_item.id][1] !== '3'"
                    :span="24"
                  >
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['1_1'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-1_1`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-1_1`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['1_1'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['1_1'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row
                  :gutter="16"
                  v-if="
                    surveys[order_item.id] &&
                      surveys[order_item.id]['1_1'] &&
                      surveys[order_item.id]['1_1'] !== '0'
                  "
                >
                  <a-col :span="24">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['1_2'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-1_2`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-1_2`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['1_2'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['1_2'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16">
                  <a-col :span="24">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['2'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-2`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-2`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['2'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['2'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['3'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-3`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-3`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['3'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['2'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col
                    :span="12"
                    v-if="
                      surveys[order_item.id] &&
                        surveys[order_item.id]['3'] &&
                        surveys[order_item.id]['3'] === '0'
                    "
                  >
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['3_1'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-3_1`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-3_1`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['3_1'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['3_1'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>

                  <a-col
                    :span="12"
                    v-if="
                      surveys[order_item.id] &&
                        surveys[order_item.id]['3'] &&
                        surveys[order_item.id]['3'] === '0'
                    "
                  >
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['3_2'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-3_2`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-3_2`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['3_2'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['3_2'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16">
                  <a-col :span="24">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['4'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-4`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-4`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['4'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['4'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row
                  :gutter="16"
                  v-if="
                    surveys[order_item.id] &&
                      surveys[order_item.id]['4'] &&
                      surveys[order_item.id]['4'] == '0'
                  "
                >
                  <!-- con quale assicurazione? -->
                  <a-col :span="12">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['4_1'].q }}</label>
                      <a-input
                        v-decorator="[
                          `${order_item.id}#survey-4_1`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-4_1`"
                        class="mt-4"
                        formErrors
                        placeholder="nome compagnia"
                      />
                    </a-form-item>
                  </a-col>
                  <!-- quando scadra la polizza? -->
                  <a-col :span="12">
                    <a-form-item :colon="false" class="add-margin-to-ant-label">
                      <label class="mb-6 font-bold" slot="label">{{ questions['4_2'].q }}</label>
                      <a-date-picker
                        :locale="locale"
                        format="DD/MM/YYYY"
                        v-decorator="[
                          `${order_item.id}#survey-4_2`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        @change="
                          val =>
                            handleSurveyChange({
                              target: { name: `${order_item.id}#survey-4_2`, value: val.toString() }
                            })
                        "
                        :disabledDate="disabledDatePast"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>

                <!-- lo è stato in passato? -->
                <a-row
                  :gutter="16"
                  v-if="
                    surveys[order_item.id] &&
                      surveys[order_item.id]['4'] &&
                      surveys[order_item.id]['4'] == '1'
                  "
                >
                  <a-col :span="12">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['4_3'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-4_3`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-4_3`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['4_3'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['4_3'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row
                  :gutter="16"
                  v-if="
                    surveys[order_item.id] &&
                      surveys[order_item.id]['4_3'] &&
                      surveys[order_item.id]['4'] &&
                      surveys[order_item.id]['4'] == '1' &&
                      surveys[order_item.id]['4_3'] == '0'
                  "
                >
                  <!-- con quale assicurazione -->
                  <a-col :span="12">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['4_3_1'].q }}</label>
                      <a-input
                        v-decorator="[
                          `${order_item.id}#survey-4_3_1`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-4_3_1`"
                        class="mt-4"
                        formErrors
                        placeholder="Oney"
                      />
                    </a-form-item>
                  </a-col>

                  <!-- quando è scadura la polizza -->
                  <a-col :span="12">
                    <a-form-item :colon="false" class="add-margin-to-ant-label">
                      <label class="mb-6 font-bold" slot="label">{{ questions['4_3_2'].q }}</label>
                      <a-date-picker
                        :locale="locale"
                        format="DD/MM/YYYY"
                        v-decorator="[
                          `${order_item.id}#survey-4_3_2`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        @change="
                          val =>
                            handleSurveyChange({
                              target: {
                                name: `${order_item.id}#survey-4_3_2`,
                                value: val.toString()
                              }
                            })
                        "
                        :disabledDate="disabledDateFuture"
                      />
                    </a-form-item>
                  </a-col>

                  <!-- perchè non è stata rinnovata la polizza? -->
                  <a-col :span="12">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['4_3_3'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-4_3_3`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-4_3_3`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['4_3_3'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['4_3_3'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>

                  <!-- se l'utente ha scelto "altro", deve specificare -->
                  <a-col
                    :span="12"
                    v-if="
                      surveys[order_item.id] &&
                        surveys[order_item.id]['4_3_3'] &&
                        surveys[order_item.id]['4_3_3'] == '1'
                    "
                  >
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">Specifica le motivazioni</label>
                      <a-input
                        v-decorator="[
                          `${order_item.id}#survey-4_3_3_other`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-4_3_3_other`"
                        class="mt-4"
                        formErrors
                        placeholder="Non ero soddisfatto del servizio clienti"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>

                <!-- Lo strumento ha subito sinistri negli ultimi 5 anni? -->
                <a-row :gutter="16">
                  <a-col :span="24">
                    <a-form-item :colon="false">
                      <label class="font-bold" slot="label">{{ questions['5'].q }}</label>
                      <a-radio-group
                        v-decorator="[
                          `${order_item.id}#survey-5`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        size="large"
                        class="mt-4"
                        @change="handleSurveyChange"
                        :name="`${order_item.id}#survey-5`"
                      >
                        <a-radio-button
                          v-for="id in Object.keys(questions['5'].a)"
                          :key="id"
                          :value="id"
                        >
                          {{ questions['5'].a[id] }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>

                <!-- se ha subito sinistri, vanno specificati -->
                <a-row
                  :gutter="8"
                  v-for="(i, index) in surveys[order_item.id] &&
                  surveys[order_item.id]['5'] &&
                  surveys[order_item.id]['5'] == '0'
                    ? incidents[order_item.id]
                    : []"
                  :key="index"
                >
                  <a-col :span="5">
                    <a-form-item :colon="false" class="add-margin-to-ant-label">
                      <label class="mb-6 font-bold" slot="label">
                        {{ $t('questions.incidentwhen') }}
                      </label>
                      <a-date-picker
                        :locale="locale"
                        format="DD/MM/YYYY"
                        :showTime="false"
                        v-decorator="[
                          `${order_item.id}#survey-5_1_when_${index}`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        @change="
                          val =>
                            handleIncidentChange(index, {
                              key: 'when',
                              orderItemId: order_item.id,
                              value: val,
                              nameFull: `${order_item.id}#survey-5_1_`,
                              name: 'survey-5_1_when'
                            })
                        "
                        :disabledDate="disabledDateFuture"
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :span="6">
                    <a-form-item :colon="false" class="add-margin-to-ant-label">
                      <label class="mb-6 font-bold" slot="label">
                        {{ $t('questions.incidentwhat') }}
                      </label>
                      <a-select
                        v-decorator="[
                          `${order_item.id}#survey-5_1_what_${index}`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        @change="
                          val =>
                            handleIncidentChange(index, {
                              key: 'what',
                              orderItemId: order_item.id,
                              value: val,
                              nameFull: `${order_item.id}#survey-5_1_`,
                              name: 'survey-5_1_what'
                            })
                        "
                      >
                        <a-select-option value="steal">{{ $t('questions.steal') }}</a-select-option>
                        <a-select-option value="fire">{{ $t('questions.fire') }}</a-select-option>
                        <a-select-option value="accident">
                          {{ $t('questions.accident') }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>

                  <a-col :span="6">
                    <a-form-item :colon="false" class="add-margin-to-ant-label">
                      <label class="font-bold" slot="label">Valore del danno</label>
                      <CurrencyInput
                        currency="EUR"
                        v-model="incidents[order_item.id][index].value"
                        :class="['price-input']"
                        inputmode="decimal"
                        :valueRange="{ min: 0 }"
                        :allowNegative="false"
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :span="7" class="pt-12 pl-8">
                    <a-button
                      v-if="incidents[order_item.id].length > 1"
                      class="btn-small"
                      @click="removeIncident(order_item.id, index)"
                    >
                      Rimuovi
                    </a-button>
                  </a-col>
                </a-row>

                <a-row
                  v-if="
                    surveys[order_item.id] &&
                      surveys[order_item.id]['5'] &&
                      surveys[order_item.id]['5'] == '0'
                  "
                >
                  <a-col>
                    <a-button class="btn-small" @click="() => addIncident(order_item.id)">
                      Aggiungi incidente
                    </a-button>
                  </a-col>
                </a-row>
              </a-form>
            </a-card>

            <add-instrument-mobile-btn
              :stopAfterStep="2"
              :onInstrumentFormCompleted="onInstrumentFormCompleted"
              :canAdd="true"
              :readonly="readonly"
            />
          </a-col>
        </a-row>
      </a-spin>
    </div>

    <div
      class="fixed bottom-0 left-0 flex items-center justify-end w-full p-4 bg-white border-t border-gray-200"
    >
      <a-button
        type="primary"
        class="big"
        @click="handleSubmit"
        :loading="submitting"
        v-if="$store.state.order.order_items.length > 0"
      >
        {{ $t('cart.nextStep') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import api from '@/api.js';
import questions from '@/questions';
import utils from '@/utils';
import locale from 'ant-design-vue/es/date-picker/locale/it_IT';
const dayjs = require('dayjs');
const moment = require('moment');

const incidentTemplate = {
  when: '',
  what: '',
  value: 0
};

export default {
  name: 'questions',

  data: function() {
    return {
      currentStep: 1,
      stepTitle: 'Compila il questionario di rischio',
      contentTitle: '2. Questionario di rischio',
      form: this.$form.createForm(this, { name: 'questionnaire' }),
      submitting: false,
      questions,
      incidents: {},
      moment,
      locale
    };
  },

  beforeMount() {
    // prepare array for incidents for each order_item
    this.$store.state.order.order_items.forEach(order_item => {
      if (!order_item.survey || !order_item.survey.incidents) {
        this.incidents[order_item.id] = [{ ...incidentTemplate }];
      }
    });
  },

  mounted() {
    this.$store.state.order.order_items.forEach(order_item => {
      const id = order_item.id;

      this.form.setFieldsValue({
        [`${id}#survey-1_1`]:
          order_item.survey && order_item.survey['1_1'] ? order_item.survey['1_1'] : null,
        [`${id}#survey-1_2`]:
          order_item.survey && order_item.survey['1_2'] ? order_item.survey['1_2'] : null,
        [`${id}#survey-2`]:
          order_item.survey && order_item.survey['2'] ? order_item.survey['2'] : null,
        [`${id}#survey-3`]:
          order_item.survey && order_item.survey['3'] ? order_item.survey['3'] : null,
        [`${id}#survey-3_1`]:
          order_item.survey && order_item.survey['3_1'] ? order_item.survey['3_1'] : null,
        [`${id}#survey-3_2`]:
          order_item.survey && order_item.survey['3_2'] ? order_item.survey['3_2'] : null,
        [`${id}#survey-4`]:
          order_item.survey && order_item.survey['4'] ? order_item.survey['4'] : null,
        [`${id}#survey-4_1`]:
          order_item.survey && order_item.survey['4_1'] ? order_item.survey['4_1'] : null,
        [`${id}#survey-4_2`]:
          order_item.survey && order_item.survey['4_2']
            ? moment(order_item.survey['4_2']).local()
            : null,
        [`${id}#survey-4_3`]:
          order_item.survey && order_item.survey['4_3'] ? order_item.survey['4_3'] : null,
        [`${id}#survey-4_3_1`]:
          order_item.survey && order_item.survey['4_3_1'] ? order_item.survey['4_3_1'] : null,
        [`${id}#survey-4_3_2`]:
          order_item.survey && order_item.survey['4_3_2']
            ? moment(order_item.survey['4_3_2']).local()
            : null,
        [`${id}#survey-4_3_3`]:
          order_item.survey && order_item.survey['4_3_3'] ? order_item.survey['4_3_3'] : null,
        [`${id}#survey-4_3_3_other`]:
          order_item.survey && order_item.survey['4_3_3_other']
            ? order_item.survey['4_3_3_other']
            : null,
        [`${id}#survey-5`]:
          order_item.survey && order_item.survey['5'] ? order_item.survey['5'] : null
      });

      // DIFFERENT MODE
      // this.form.setFields({
      //   [`${id}#survey-1_1`]: { value: order_item.survey ? order_item.survey['1_1'] : null },
      //   [`${id}#survey-1_2`]: { value: order_item.survey ? order_item.survey['1_2'] : null },
      //   [`${id}#survey-2`]: { value: order_item.survey ? order_item.survey['2'] : null },
      //   [`${id}#survey-3`]: { value: order_item.survey ? order_item.survey['3'] : null },
      //   [`${id}#survey-3_1`]: { value: order_item.survey ? order_item.survey['3_1'] : null },
      //   [`${id}#survey-4`]: { value: order_item.survey ? order_item.survey['4'] : null },
      //   [`${id}#survey-4_1`]: { value: order_item.survey ? order_item.survey['4_1'] : null },
      //   // [`${id}#survey-4_2`]: {
      //   //   value: order_item.survey ? moment(order_item.survey['4_2']).local() : null
      //   // }
      //   [`${id}#survey-4_3`]: { value: order_item.survey ? order_item.survey['4_3'] : null },
      //   [`${id}#survey-4_3_1`]: { value: order_item.survey ? order_item.survey['4_3_1'] : null },
      //   [`${id}#survey-4_3_2`]: {
      //     value:
      //       order_item.survey && order_item.survey['4_3_2']
      //         ? moment(order_item.survey['4_3_2']).local()
      //         : null
      //   },
      //   [`${id}#survey-4_3_3`]: { value: order_item.survey ? order_item.survey['4_3_3'] : null },
      //   [`${id}#survey-4_3_3_other`]: {
      //     value:
      //       order_item.survey && order_item.survey['4_3_3_other']
      //         ? order_item.survey['4_3_3_other']
      //         : null
      //   },
      //   [`${id}#survey-5`]: { value: order_item.survey ? order_item.survey['5'] : nul }
      // });

      // load incident if exist
      if (order_item.survey && order_item.survey['incidents']) {
        this.incidents[id] = order_item.survey['incidents'];
        this.$nextTick(() => {
          this.incidents[id].forEach((incident, i) => {
            this.form.setFieldsValue({
              [`${incident.fieldName}what_${i}`]: incident.what,
              [`${incident.fieldName}when_${i}`]: moment(incident.when).local()
            });
          });
        });
      }
      this.$forceUpdate();
    });
  },

  computed: {
    readonly() {
      return !!this.$store.state.order.chosen_offer;
    },

    mobile() {
      return this.$mq.resize && this.$mq.below('768px');
    },

    order() {
      return this.$store.state.order;
    },
    surveys() {
      if (!this.order) return {};

      const surveys = {};

      this.order.order_items.forEach(order_item => {
        surveys[order_item.id] = order_item.survey;
      });

      return surveys;
    }
  },

  methods: {
    async onInstrumentFormCompleted(id, form, survey) {
      try {
        await api.addOrderItem(id, { ...form, survey });
      } catch (e) {
        this.$notification.error({
          message: "C'è stato un errore nell'inserimento dello strumento nel carrello. Contattaci!",
          duration: 300
        });
        return;
      }

      await this.$store.dispatch('getOrder', true);
    },

    removeIncident(orderItemId, index) {
      this.incidents[orderItemId].splice(index, 1);

      this.$nextTick(() => {
        this.incidents[orderItemId].forEach((incident, i) => {
          this.form.setFieldsValue({
            [`${incident.fieldName}what_${i}`]: incident.what,
            [`${incident.fieldName}when_${i}`]: incident.when
          });
        });
      });

      this.$forceUpdate();
    },

    addIncident(orderItemId) {
      this.incidents[orderItemId].push({ ...incidentTemplate });
      this.$forceUpdate();
    },

    handleIncidentChange(index, data) {
      this.incidents[data.orderItemId][index][data.key] = data.value;
      this.incidents[data.orderItemId][index].fieldName = data.nameFull;
    },

    handleSubmit() {
      if (this.readonly) {
        return this.$router.push({ name: 'offers' });
      }

      this.submitting = true;

      this.form.validateFieldsAndScroll(
        { scroll: { offsetTop: 30, alignWithTop: true } },
        async (err, values) => {
          if (err) {
            console.log('Form is invalid: ', values);
            this.submitting = false;
            return;
          }

          let valuesPerInstrument = {};

          Object.keys(values).forEach(fieldId => {
            let [instrumentId, fieldName] = fieldId.split('#');

            if (!valuesPerInstrument[parseInt(instrumentId)]) {
              valuesPerInstrument[parseInt(instrumentId)] = { survey: {} };
            }

            // handle properly survey's fields
            if (fieldName.includes('survey')) {
              let [, questionId] = fieldName.split('-');
              valuesPerInstrument[parseInt(instrumentId)].survey[questionId] = values[fieldId];
            } else {
              valuesPerInstrument[parseInt(instrumentId)][fieldName] = values[fieldId];
            }
          });

          // handle incidents
          Object.keys(this.incidents).forEach(instrumentId => {
            if (valuesPerInstrument[parseInt(instrumentId)].survey['5'] == 0) {
              valuesPerInstrument[parseInt(instrumentId)].survey.incidents = this.incidents[
                parseInt(instrumentId)
              ];
            }
          });

          let payload = {};
          for (let id in valuesPerInstrument) payload[id] = valuesPerInstrument[id].survey;
          await api.saveSurveyOrderItems(payload);

          const order = await this.$store.dispatch('getOrder', true);
          this.submitting = false;

          let routeParams = {};
          if (!order.chosen_offer) {
            routeParams.l = 1;
          }

          this.$router.push({ name: 'offers', query: routeParams });
        }
      );
    },

    disabledDatePast(current) {
      // Can not select days before today and today
      return current && current < dayjs().startOf('day');
    },

    disabledDateFuture(current) {
      // Can not select days after today and today
      return current && current > dayjs().endOf('day');
    },

    handleSurveyChange(e) {
      const { instrumentId, questionId } = utils.extractIdsFromSurveyIdString(e.target.name);

      let val = e.target.value;

      // reset incidents in the case the answer is "no" (1)
      if (questionId == 5 && val == 1) {
        this.$set(this.incidents, instrumentId, [{ ...incidentTemplate }]);
      }

      this.$store.commit('updateSurveryLocally', {
        answerId: val,
        questionId,
        instrumentId: parseInt(instrumentId)
      });
    }
  }
};
</script>
<style lang="scss">
.add-margin-to-ant-label .ant-form-item-label {
  margin-bottom: 19px;
}
</style>
